<template>
    <div class="py-2 shadow-lg min-h-20 z-10 relative">
        <div :class="innerClass">
            <slot />
        </div>
    </div>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const props = defineProps<{ wide?: boolean; class?: HTMLAttributes["class"] }>();

const innerClass = computed(() =>
    cn(props.wide ? "container-fluid" : "container", "flex gap-8 items-center", props.class)
);
</script>
